/**
 * Formato listo para pegar en WhatsApp (recordatorios y guías).
 * No envía por API: copia / enlace wa.me. El canal vivo sigue siendo Mensajes en app.
 */

/**
 * @param {string} body
 * @param {{ name?: string, company?: string }=} opts
 */
export function formatWhatsAppText(body, opts = {}) {
    const name = (opts.name || '').trim();
    const company = (opts.company || '').trim();
    const greeting = name ? `Hola ${name.split(' ')[0]},` : 'Hola,';
    const footer = company ? `\n\n— Equipo ${company} · ALINEA` : '\n\n— ALINEA';
    return `${greeting}\n\n${String(body || '').trim()}${footer}`;
}

/**
 * @param {string} phoneDigits E.164 sin + (ej. 573001234567) o vacío
 * @param {string} text
 */
export function whatsappShareUrl(phoneDigits, text) {
    const phone = String(phoneDigits || '').replace(/\D/g, '');
    const q = encodeURIComponent(text || '');
    if (phone) return `https://wa.me/${phone}?text=${q}`;
    return `https://wa.me/?text=${q}`;
}

export async function copyWhatsAppMessage(body, opts = {}) {
    const text = formatWhatsAppText(body, opts);
    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
    }
    return text;
}
